// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  cid: '466010',
  api: {
    //base_url: 'http://localhost:3000',
    base_url: 'https://stg-api7.ojo7.com',
    paths: {
      validateDuplicatedLead: '/lead/validate',
      createLead: '/lead',
      getCatalogs: '/catalog/lenders/amigocredi',
      getCatalogState: '/catalog/states',
      getCurp: '/lead/curp',
      getLocalities: '/catalog/localities',
      getEmployment: '/catalog/employment_status',
      getRedirectUrl: '/linktrust/redirect',
      moneyman_apply: '/lead/moneyman/apply',
      ltClick: '/linktrust/click',
      validateEmail: '/email/validate',
      offerwallClick: '/offerwall',
      offerwallOption: '/offerwall-option',
      providentAcceptOffer: '/api/provident/offer-approval',
      createLandingsLead: '/moneymarket/landings/lead',
      updateShownInPingtree: '/lead/scoring/shown'
    }
  },
  catalogs_tmp: [
    {
      "id": 44,
      "name": "loan.amigocredi",
      "value": "$500"
    },
    {
      "id": 46,
      "name": "loan.amigocredi",
      "value": "$1000"
    },
    {
      "id": 47,
      "name": "loan.amigocredi",
      "value": "$1250"
    },
    {
      "id": 48,
      "name": "loan.amigocredi",
      "value": "$1500"
    },
    {
      "id": 50,
      "name": "loan.amigocredi",
      "value": "$2000"
    },
    {
      "id": 52,
      "name": "loan.amigocredi",
      "value": "$2500"
    },
    {
      "id": 54,
      "name": "loan.amigocredi",
      "value": "$3000"
    },
    {
      "id": 56,
      "name": "loan.amigocredi",
      "value": "$3500"
    },
    {
      "id": 58,
      "name": "loan.amigocredi",
      "value": "$4000"
    },
    {
      "id": 62,
      "name": "loan.amigocredi",
      "value": "$5000"
    },
    {
      "id": 66,
      "name": "loan.amigocredi",
      "value": "$6000"
    },
    {
      "id": 67,
      "name": "loan_purpose.amigocredi",
      "value": "Para mi negocio"
    },
    {
      "id": 68,
      "name": "loan_purpose.amigocredi",
      "value": "Gastos médicos"
    },
    {
      "id": 69,
      "name": "loan_purpose.amigocredi",
      "value": "Emergencia / Imprevistos"
    },
    {
      "id": 70,
      "name": "loan_purpose.amigocredi",
      "value": "Reformas de casa"
    },
    {
      "id": 71,
      "name": "loan_purpose.amigocredi",
      "value": "Gastos para estudios"
    },
    {
      "id": 72,
      "name": "loan_purpose.amigocredi",
      "value": "Regalos"
    },
    {
      "id": 73,
      "name": "loan_purpose.amigocredi",
      "value": "Pagar deudas"
    },
    {
      "id": 74,
      "name": "loan_purpose.amigocredi",
      "value": "Gastos del coche"
    },
    {
      "id": 75,
      "name": "loan_purpose.amigocredi",
      "value": "Gastos personales"
    },
    {
      "id": 76,
      "name": "loan_purpose.amigocredi",
      "value": "Vacaciones"
    },
    {
      "id": 77,
      "name": "loan_purpose.amigocredi",
      "value": "Ropa"
    },
    {
      "id": 78,
      "name": "loan_purpose.amigocredi",
      "value": "Comida"
    },
    {
      "id": 79,
      "name": "loan_purpose.amigocredi",
      "value": "Otros Gastos"
    },
    {
      "id": 80,
      "name": "return_days.amigocredi",
      "value": "7 días"
    },
    {
      "id": 81,
      "name": "return_days.amigocredi",
      "value": "14 días"
    },
    {
      "id": 82,
      "name": "return_days.amigocredi",
      "value": "21 días"
    },
    {
      "id": 83,
      "name": "return_days.amigocredi",
      "value": "30 días"
    },
    {
      "id": 88,
      "name": "marital_status.amigocredi",
      "value": "Casado(a)"
    },
    {
      "id": 89,
      "name": "marital_status.amigocredi",
      "value": "Soltero(a)"
    },
    {
      "id": 90,
      "name": "marital_status.amigocredi",
      "value": "Divorciado(a)"
    },
    {
      "id": 91,
      "name": "marital_status.amigocredi",
      "value": "Viudo(a)"
    },
    {
      "id": 92,
      "name": "income_check.amigocredi",
      "value": "Recibo de nómina"
    },
    {
      "id": 93,
      "name": "income_check.amigocredi",
      "value": "Estado de cuenta"
    },
    {
      "id": 94,
      "name": "income_check.amigocredi",
      "value": "Carta patronal"
    },
    {
      "id": 95,
      "name": "income_check.amigocredi",
      "value": "No tengo manera"
    },
    {
      "id": 96,
      "name": "income_check.amigocredi",
      "value": "Otro1"
    },
    {
      "id": 152,
      "name": "reference_type.amigocredi",
      "value": "Madre"
    },
    {
      "id": 153,
      "name": "reference_type.amigocredi",
      "value": "Padre"
    },
    {
      "id": 154,
      "name": "reference_type.amigocredi",
      "value": "Hermano o Hermana"
    },
    {
      "id": 155,
      "name": "reference_type.amigocredi",
      "value": "Hijo"
    },
    {
      "id": 156,
      "name": "reference_type.amigocredi",
      "value": "Tía o Tío"
    },
    {
      "id": 157,
      "name": "reference_type.amigocredi",
      "value": "Primo"
    },
    {
      "id": 158,
      "name": "reference_type.amigocredi",
      "value": "Amigo"
    },
    {
      "id": 159,
      "name": "reference_type.amigocredi",
      "value": "Colega"
    },
    {
      "id": 160,
      "name": "education.amigocredi",
      "value": "Educación básica"
    },
    {
      "id": 161,
      "name": "education.amigocredi",
      "value": "Bachillerato"
    },
    {
      "id": 162,
      "name": "education.amigocredi",
      "value": "Universidad"
    },
    {
      "id": 163,
      "name": "industry.amigocredi",
      "value": "Construcción"
    },
    {
      "id": 164,
      "name": "industry.amigocredi",
      "value": "Producción base de metal"
    },
    {
      "id": 165,
      "name": "industry.amigocredi",
      "value": "Comercio"
    },
    {
      "id": 166,
      "name": "industry.amigocredi",
      "value": "Alimentación"
    },
    {
      "id": 167,
      "name": "industry.amigocredi",
      "value": "Transportación"
    },
    {
      "id": 168,
      "name": "industry.amigocredi",
      "value": "Servicios profecionales"
    },
    {
      "id": 169,
      "name": "industry.amigocredi",
      "value": "Educación"
    },
    {
      "id": 170,
      "name": "industry.amigocredi",
      "value": "Refinación del petróleo"
    },
    {
      "id": 171,
      "name": "industry.amigocredi",
      "value": "Otro"
    },
    {
      "id": 172,
      "name": "industry.amigocredi",
      "value": "Funcionario público"
    },
    {
      "id": 173,
      "name": "industry.amigocredi",
      "value": "Finanzas"
    },
    {
      "id": 174,
      "name": "industry.amigocredi",
      "value": "Servicios de salud"
    },
    {
      "id": 175,
      "name": "industry.amigocredi",
      "value": "Turismo"
    },
    {
      "id": 176,
      "name": "industry.amigocredi",
      "value": "Medios"
    },
    {
      "id": 177,
      "name": "industry.amigocredi",
      "value": "Colega"
    },
    {
      "id": 178,
      "name": "industry.amigocredi",
      "value": "Textiles"
    },
    {
      "id": 179,
      "name": "industry.amigocredi",
      "value": "Telecomunicaciones"
    },
    {
      "id": 180,
      "name": "industry.amigocredi",
      "value": "Ingeniería mecánica y electricidad"
    },
    {
      "id": 181,
      "name": "industry.amigocredi",
      "value": "Militar"
    },
    {
      "id": 182,
      "name": "industry.amigocredi",
      "value": "Industria química"
    },
    {
      "id": 183,
      "name": "industry.amigocredi",
      "value": "Fabricación de equipos de transporte"
    },
    {
      "id": 184,
      "name": "industry.amigocredi",
      "value": "Agricultura"
    },
    {
      "id": 185,
      "name": "industry.amigocredi",
      "value": "Servicios públicos"
    },
    {
      "id": 186,
      "name": "industry.amigocredi",
      "value": "Transporte marítimo"
    },
    {
      "id": 187,
      "name": "industry.amigocredi",
      "value": "Ciencias forestales"
    },
    {
      "id": 188,
      "name": "industry.amigocredi",
      "value": "Minería"
    },
    {
      "id": 189,
      "name": "historial.amigocredi",
      "value": "Siempre pago mis deudas. Y a tiempo."
    },
    {
      "id": 190,
      "name": "historial.amigocredi",
      "value": "A veces me he retrasado un poco."
    },
    {
      "id": 191,
      "name": "historial.amigocredi",
      "value": "Tengo deudas pendientes."
    },
    {
      "id": 192,
      "name": "historial.amigocredi",
      "value": "Nunca he pedido un préstamo antes."
    },
    {
      "id": 256,
      "name": "loan.amigocredi",
      "value": "Mas de $6000"
    }
  ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
